import {doc} from '../docs.js';
import {float, utils, extract} from './utils.js';
import {extractCode} from './extract.js';
import {lazy} from './lazy.js';
import {gl} from './struct.js';

doc(
    "gl.mat3",
    {
        "x": "",
        "y": "",
        "z": "",
    },
    "Creates a GLSL expression representing a 3x3 matrix",
    () => 1, {
        isHot: true,
        tags: "GLSL",
        inlets: 3
    });


export const gl_mat3 = (object, b,c) => {
    return lazy((a) => {
        let codes  = extractCode(a,b,c);
        object.flash();
        return `mat3(${float(codes[0])}, ${float(codes[1])}, ${float(codes[2])})`;
    }, b, c);
};

